<footer class="main-footer">
  <div class="container-dynamic d-flex">
    <!-- <a
      mat-raised-button
      color="accent"
      routerLink="/others/precos"
      >Assine agora</a
    > -->
    <span class="m-auto"></span>
     <a *ngIf="!layoutConf.isMobile" href="https://infokaw.com.br/jkawflex"> Infokaw Software - Soluções em Software </a>
     <!-- Versão sempre visível (inclusive mobile) -->
     <a class="app-version" (click)="openAbout()"
        [matTooltip]="'Front v' + appInfo.info.version + ' · ' + appInfo.info.commit + (backendBuild ? ' — Backend: ' + backendBuild : '') + ' — clique para detalhes'">
       v{{ appInfo.info.version }} · {{ appInfo.info.commit }}
       <span class="backend-build" *ngIf="backendBuild"> · api {{ backendBuild }}</span>
     </a>
  </div>
</footer>
